import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login-page.component').then((c) => c.LoginPageComponent),
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./services/auth-callback/auth-callback.component').then(
        (c) => c.CallbackComponent
      ),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home.component').then((m) => m.HomeComponent),
    children: [
      {
        path: 'contacts',
        loadChildren: () =>
          import('./contacts/contacts.routes').then((m) => m.routes),
      },
      {
        path: 'candidates',
        loadChildren: () =>
          import('./candidates/candidates.routes').then((m) => m.routes),
      },
      {
        path: 'companies',
        loadChildren: () =>
          import('./companies/companies.routes').then((m) => m.routes),
      },
      {
        path: 'positions',
        loadChildren: () =>
          import('./positions/positions.routes').then((m) => m.routes),
      },
      {
        path: 'appointments',
        loadChildren: () =>
          import('./appointments/appointments.routes').then((m) => m.routes),
      },
      {
        path: 'calendars',
        loadChildren: () =>
          import('./calendar/calendar.routes').then((m) => m.routes),
      },
      {
        path: 'appointments-config',
        loadChildren: () =>
          import('./appointments-config/appointments-config.routes').then(
            (m) => m.routes
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./users/users.routes').then((m) => m.routes),
      },
      {
        path: 'availabilities',
        loadChildren: () =>
          import('./availabilities/availabilities.routes').then(
            (m) => m.routes
          ),
      },
      {
        path: 'status-config',
        loadChildren: () =>
          import('./status-config/status-config.routes').then((m) => m.routes),
      },
      {
        path: 'sources',
        loadChildren: () =>
          import('./sources/sources.routes').then((m) => m.routes),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.routes').then((m) => m.routes),
      },
    ],
  },
];
